export const parseMaybeJson = (value, depth = 0) => {
  if (typeof value !== "string") return value;

  const trimmed = value.trim();
  if (!trimmed || !["{", "[", '"'].includes(trimmed[0])) return value;

  try {
    const parsed = JSON.parse(trimmed);
    return typeof parsed === "string" && depth < 1
      ? parseMaybeJson(parsed, depth + 1)
      : parsed;
  } catch {
    return value;
  }
};

export const asPdfArray = (value) => {
  const parsed = parseMaybeJson(value);
  return Array.isArray(parsed) ? parsed : [];
};

export const asPdfObject = (value) => {
  const parsed = parseMaybeJson(value);
  return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
};

export const asPdfBoolean = (value, fallback = true) => {
  if (value === undefined || value === null || value === "") return fallback;
  return value === true || value === 1 || value === "1" || String(value).toLowerCase() === "true";
};

export const toPdfText = (value) => {
  if (typeof value === "string") return value.trim();
  if (typeof value === "number" && Number.isFinite(value)) return String(value);
  return "";
};

// rich text (editor HTML) as plain text for the PDF : the tags are dropped, the line breaks and entities kept
export const plainText = (value) =>
  toPdfText(value)
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, "")
    .replace(/<br\s*\/?>|<\/(?:p|div|li|tr|h[1-6])>/gi, "\n")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;|&#160;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&#(x[0-9a-f]+|\d+);/gi, (entity, code) => {
      const number = code[0].toLowerCase() === "x" ? parseInt(code.slice(1), 16) : Number(code);
      return number > 0 && number <= 0x10ffff ? String.fromCodePoint(number) : entity;
    })
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();

export const toPdfNumber =(value, fallback, { min = -Number.MAX_VALUE, max = Number.MAX_VALUE } = {}) => {
  const parsed = value === "" || value === null || value === undefined ? NaN : Number(value);
  const fallbackNumber = Number(fallback);
  const safeFallback = Number.isFinite(fallbackNumber) ? fallbackNumber : 0;
  const safeValue = Number.isFinite(parsed) ? parsed : safeFallback;

  return Math.min(max, Math.max(min, safeValue));
};

const HEX_COLOR = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const NAMED_COLOR = /^[a-z]+$/i;
const FUNCTION_COLOR = /^(?:rgb|rgba|hsl|hsla)\([^)]*\)$/i;

export const toPdfColor = (value, fallback) => {
  const color = toPdfText(value);
  return HEX_COLOR.test(color) || NAMED_COLOR.test(color) || FUNCTION_COLOR.test(color)
    ? color
    : fallback;
};
